import { createExperiencePage } from "../shared/createExperiencePage";

const defaultContent = {
  meta: {
    title: "Husky Ride Experience in Lapland | Cold Experience",
    description:
      "Lead your own husky team through silent forests and across snow-covered marshes with guidance from our family of mushers.",
    keywords:
      "husky ride lapland, dog sledding sweden, husky tour arctic, cold experience",
    ogTitle: "Husky Ride Adventure in Swedish Lapland",
    ogDescription:
      "Drive a team of Siberian huskies, learn mushing techniques and warm up by the fire with our local guides.",
    ogImage: "/og/husky-ride.jpg",
    siteUrl: "https://coldexperience.se",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "TouristAttraction",
      name: "Husky Ride Experience Lapland",
      description:
        "Dog sledding tours with Siberian huskies, including instruction, winter clothing and hot refreshments.",
      image: "/og/husky-ride.jpg",
      provider: {
        "@type": "Organization",
        name: "Cold Experience Lapland",
      },
      location: {
        "@type": "Place",
        name: "Råstrand, Swedish Lapland",
      },
      url: "https://coldexperience.se/en/husky-ride",
    },
  },
  media: {
    videoSrc: "/optimized_videos/hundspann1-opt.mp4",
    poster: "/images/Nya_bilder/IMG_6702.webp",
    introVideo: "/optimized_videos/hundspann2-opt.mp4",
    introPoster: "/images/Nya_bilder/IMG_3838.webp",
    scale: 1.5,
  },
  hero: {
    title: "Husky Ride Adventure",
    description:
      "Partner with our friendly Siberian huskies and glide through Lapland's powdery trails.",
    primaryButton: {
      label: "Book Husky Ride",
      target: "book",
    },
    secondaryButton: {
      label: "Chat with a musher",
      target: "contact",
    },
  },
  intro: {
    heading: "Drive your own team",
    paragraphs: [
      "After a hands-on introduction you'll take the reins and learn to steer a husky team the way locals have done for generations.",
      "The tour finishes around the fire where we share stories about our dogs and life as a Lapland family business.",
    ],
  },
  features: [
    {
      icon: "PawPrint",
      title: "Well-trained huskies",
      description:
        "Friendly, energetic dogs that love to run and be cuddled afterwards.",
    },
    {
      icon: "Wind",
      title: "Authentic trails",
      description:
        "Guide-led routes through forests, over lakes and along ridgelines.",
    },
    {
      icon: "Users",
      title: "Small groups",
      description:
        "Private tours for families and friends with two guests per sled.",
    },
    {
      icon: "Heart",
      title: "Care & welfare",
      description:
        "Learn about our training routine and how we care for the pack all year.",
    },
  ],
  sectionsHeading: "Everything included in your husky tour",
  sections: [
    {
      id: "tourHighlights",
      title: "On the trail",
      icon: "CheckCircle",
      items: [
        "Meet the huskies and help harness the team",
        "Driving lesson from your personal musher",
        "Scenic run of 12-18 km depending on conditions",
        "Midway photo stops on frozen lakes",
        "Hot drinks and Lapland fika by the fire",
        "Opportunity to feed and thank your dogs",
      ],
    },
    {
      id: "dogFacts",
      title: "Good to know",
      icon: "PawPrint",
      items: [
        "Thermal suits, boots, gloves and hats provided",
        "Children ride safely in the guide's sled",
        "We adjust pace for weather and group comfort",
        "Professional photos available on request",
        "Transport from Skellefteå or Lycksele can be arranged",
        "Vegan and allergy-friendly fika on request",
      ],
    },
  ],
  dayProgram: {
    title: "Typical tour schedule",
    steps: [
      {
        icon: "Users",
        title: "Welcome & clothing",
        description:
          "Arrive at the kennel, meet the team and change into winter gear.",
      },
      {
        icon: "PawPrint",
        title: "Mushing lesson",
        description:
          "Learn commands, braking and turning together with your guide.",
      },
      {
        icon: "Snowflake",
        title: "Trail adventure",
        description:
          "Drive your sled or relax as a passenger while the dogs run.",
      },
      {
        icon: "Coffee",
        title: "Fika & stories",
        description:
          "Warm drinks, local pastries and time to cuddle the huskies.",
      },
    ],
  },
  closing: {
    title: "Join our husky family",
    description:
      "Plan your dog sledding adventure in Lapland and let us match the perfect tour to your group.",
    primaryButton: {
      label: "Reserve Husky Tour",
      target: "book",
    },
    secondaryButton: {
      label: "Contact the mushers",
      target: "contact",
    },
    showStarRating: true,
    ratingText: "Guest favourite winter memory",
  },
  settings: {
    showFooter: false,
  },
};

export default createExperiencePage({
  translationKey: "huskyRide",
  defaultContent,
  routeKey: "husky-ride",
});


